import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { getClients } from '../../../services/api'; // Função para buscar clientes

const ConsultarClientes = () => {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');

    useEffect(() => {
        const fetchClients = async () => {
            setLoading(true);
            try {
                const response = await getClients();
                setClients(response.data);
            } catch (error) {
                console.error("Erro ao buscar clientes", error);
            }
            setLoading(false);
        };

        fetchClients();
    }, []);

    const header = (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="p-input-icon-right">
                <InputText 
                    type="search" 
                    onInput={(e) => setGlobalFilter(e.target.value)} 
                    placeholder="Pesquisar por clientes" 
                    size="50" 
                />
                <i className="pi pi-search" style={{ right: '10px' }} />
            </span>
        </div>
    );

    const actionBodyTemplate = (rowData) => {
        const user = JSON.parse(localStorage.getItem('user'));
        const isAdmin = user && user.seccao === 'Admin';
        return (
            <div>
                <Button 
                    icon="pi pi-shopping-cart" 
                    className="p-button-rounded p-button-text" 
                    onClick={() => handleOpenOrders(rowData)}
                />
                <Button 
                    icon="pi pi-info-circle" 
                    className="p-button-rounded p-button-text" 
                    onClick={() => handleOpenDetails(rowData)}
                />
                {isAdmin && (
                    <Button 
                        icon="pi pi-trash" 
                        className="p-button-rounded p-button-text p-button-danger" 
                        onClick={() => handleDelete(rowData)}
                    />
                )}
            </div>
        );
    };
    
    
    // Exemplo de implementação das funções de ação:
    const handleOpenOrders = (client) => {
        console.log("Abrir encomendas para:", client);
        // Implemente a lógica para abrir a tela de encomendas do cliente
    };
    
    const handleOpenDetails = (client) => {
        console.log("Abrir detalhes do cliente:", client);
        // Implemente a lógica para abrir os detalhes do cliente
    };
    
    const handleDelete = (client) => {
        console.log("Excluir cliente:", client);
        // Implemente a lógica para confirmar e excluir o cliente
    };


    return (
        <Card title="Consultar Clientes">
            <DataTable 
                value={clients} 
                paginator 
                rows={10} 
                header={header} 
                globalFilter={globalFilter} 
                loading={loading}
                responsiveLayout="scroll"
                emptyMessage="Nenhum cliente encontrado."
            >
                <Column field="nome2" header="Abreviatura" sortable />
                <Column field="name" header="Nome" sortable />
                <Column field="phone" header="Telefone" sortable />
                <Column field="email" header="Email" sortable />
                <Column body={actionBodyTemplate} header="Ações" exportable={false} style={{ minWidth: '8rem' }} />
            </DataTable>
        </Card>
    );
};

export default ConsultarClientes;
